<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        @if (!requestFromEquipment) {
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label for="rentalType">Rental Type</label>
                        <wj-combo-box
                            id="rentalType"
                            [(ngModel)]="target.rentalType"
                            name="rentalType"
                            [itemsSource]="rentalTypeMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }
        @if (target.rentalType !== 1) {
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label for="equipment">Equipment</label>
                        <wj-combo-box
                            id="equipment"
                            [(ngModel)]="target.equipment"
                            name="equipment"
                            [isRequired]="false"
                            [itemsSource]="equipmentMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }
        @if (target.rentalType !== 2 && !requestFromEquipment) {
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label for="category">Category</label>
                        <wj-combo-box
                            id="category"
                            [(ngModel)]="target.category"
                            name="category"
                            [isRequired]="false"
                            [itemsSource]="categoryMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }
        @if (target.rentalType === 1) {
            <div class="row">
                <div class="col-sm-6 col-12">
                    <div class="form-group">
                        <label for="fromJob">From Rental Company</label>
                        <wj-combo-box
                            id="fromJob"
                            [(ngModel)]="target.fromJob"
                            name="fromJob"
                            [itemsSource]="vendorMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
                <div class="col-sm-6 col-12">
                    <div class="form-group">
                        <label for="billingCycle">Rental Length</label>
                        <wj-combo-box
                            id="billingCycle"
                            [(ngModel)]="target.billingCycle"
                            name="billingCycle"
                            [itemsSource]="billingCycleMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }
        @if (target.rentalType === 1) {
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label for="serialNum">Rental Serial Number</label>
                        <input id="serialNum" type="text" class="form-control" [(ngModel)]="target.serialNum" name="serialNum" />
                    </div>
                </div>
            </div>
        }
        @if (target.rentalType !== 1) {
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label for="fromJob2">From Job</label>
                        <wj-combo-box
                            id="fromJob2"
                            [(ngModel)]="target.fromJob"
                            name="fromJob"
                            [isRequired]="false"
                            [itemsSource]="jobMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }
        @if (target.rentalType === 2) {
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label for="forJob">To Rental Company</label>
                        <wj-combo-box
                            id="forJob"
                            [(ngModel)]="target.forJob"
                            name="forJob"
                            [itemsSource]="vendorMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }
        @if (target.rentalType !== 2) {
            <div class="row">
                <div class="col-sm-12 col-12">
                    <div class="form-group">
                        <label for="forJob2">For Job</label>
                        <wj-combo-box
                            id="forJob2"
                            [(ngModel)]="target.forJob"
                            name="forJob"
                            [isRequired]="false"
                            [itemsSource]="jobMap2"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="requestedByHrRef">Requested By</label>
                    <wj-combo-box
                        id="requestedByHrRef"
                        [(ngModel)]="target.requestedByHrRef"
                        name="requestedByHrRef"
                        [itemsSource]="userMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="dateNeeded">Date Needed</label>
                    <wj-input-date id="dateNeeded" [(ngModel)]="target.dateNeeded" name="dateNeeded" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="notes">Notes</label>
                    <textarea id="notes" rows="3" class="form-control" [(ngModel)]="target.notes" name="notes"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <button id="btnPhoto" type="button" class="btn btn-secondary" style="width: 100%" (click)="fileInput.click()">
                        <fa-icon class="d-none d-sm-inline-block" [icon]="faCamera"></fa-icon> Take a Photo
                    </button>
                    <input #fileInput style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*" multiple />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <button id="btnVideo" type="button" class="btn btn-secondary" style="width: 100%" (click)="videoInput.click()">
                        <fa-icon class="d-none d-sm-inline-block" [icon]="faVideo"></fa-icon> Upload a Video (.mp4)
                    </button>
                    <input #videoInput style="display: none" type="file" (change)="onFileChangedVideo($event)" accept=".mp4" multiple />
                </div>
            </div>
        </div>
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <div class="col-12">
                    <h5>Images/Videos</h5>
                </div>
                @for (url of target.imageUrls; track url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        @if (canShowImage(url)) {
                            <img style="width: 100%" [src]="'./Resources/Images/EquipmentRequest/' + url + '?w=300'" />
                        }
                        @if (canShowVideo(url)) {
                            <video controls style="width: 100%" [src]="'./Resources/Images/EquipmentRequest/' + url"></video>
                        }
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <div class="col-12">
                    <h5>Images To Upload</h5>
                </div>
                @for (image of images; track image) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="image.url" />
                    </div>
                }
            </div>
        }
        @if (videos && videos.length > 0) {
            <div class="row">
                <div class="col-12">
                    <h5>Videos To Upload</h5>
                </div>
                @for (video of videos; track video) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeVideo(video)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <video controls style="width: 100%" [src]="video.previewSrc"></video>
                    </div>
                }
            </div>
        }

        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
